// Robust cross-browser smooth scroll to a section by id.
// Fixes issues on older Android Chrome / WebViews where
// element.scrollIntoView({behavior:'smooth'}) is unsupported and silently fails.
//
// Strategy:
// 1. Compute target Y using getBoundingClientRect + pageYOffset.
// 2. Subtract the fixed header height so the section title isn't hidden.
// 3. Feature-detect smooth scroll; fall back to instant scroll on older Android.

const HEADER_OFFSET = 80; // px, matches fixed header height

const supportsSmoothScroll = () => {
  try {
    return 'scrollBehavior' in document.documentElement.style;
  } catch (_) {
    return false;
  }
};

export const scrollToSection = (sectionId) => {
  const el = document.getElementById(sectionId);
  if (!el) return;

  const rect = el.getBoundingClientRect();
  const targetY = Math.max(
    0,
    rect.top + window.pageYOffset - HEADER_OFFSET
  );

  if (supportsSmoothScroll()) {
    try {
      window.scrollTo({ top: targetY, left: 0, behavior: 'smooth' });
      return;
    } catch (_) {
      // fall through to instant scroll
    }
  }

  // Fallback for older Android Chrome / WebViews without smooth scroll.
  window.scrollTo(0, targetY);
};

export default scrollToSection;
